var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from '../../../styles';
export function Pin(props) {
    const { enabled } = props, rest = __rest(props, ["enabled"]);
    const theme = useTheme();
    return (React.createElement(React.Fragment, null, !enabled ? (React.createElement("svg", Object.assign({ width: "10", height: "18", viewBox: "0 0 10 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest),
        React.createElement("path", { d: "M6.66667 8.34579V2.16662H7.5V1.33329H1.66667V2.16662H2.5V8.34496L0.833333 10.0116V10.5H8.33333V10.0116L6.66667 8.34496V8.34579ZM9.16667 9.66496V11.3316L5 11.3333V15.0833L4.58333 16.3333L4.16667 15.0833V11.3333L0 11.3316V9.66496H0.00166655L1.66667 7.99996V2.99829H0.833333V0.498291H8.3325V2.99829H7.49917V7.99996L9.16583 9.66496H9.16667Z", fill: theme.colors.icon.default }))) : (React.createElement("svg", Object.assign({ width: "10", height: "18", viewBox: "0 0 10 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest),
        React.createElement("path", { d: "M8.33333 8.99996V2.33329H9.16667V0.666626H0.833333V2.33329H1.66667V8.99996L0 10.6666V12.3333H4.33333V17.3333H5.66667V12.3333H10V10.6666L8.33333 8.99996Z", fill: theme.colors.primary.main })))));
}
//# sourceMappingURL=Pin.js.map